import styled, { css } from 'styled-components';
import { FooterLink } from '../styles';
import { SocialMediaType } from '.';

export const SocialLink = styled(FooterLink)<{ $mediaType: SocialMediaType }>(
  ({ theme, $mediaType }) => css`
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    display: flex;
    align-items: center;
    justify-content: center;
    border: ${theme.bo.thinWidth} solid ${theme.co.neutral99};
    border-radius: ${theme.bo.round};
    color: inherit;
    ${theme.typography.heading.desktop.xxxs};

    &:hover {
      border-color: ${theme.co.primary20};
    }

    svg {
      width: ${
        /* istanbul ignore next: tested visually */
        $mediaType === 'facebook' ? theme.sz.s2 : theme.sz.s4
      };
    }
  `,
);
